import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import App from './App';
import './utils/install';   // registers beforeinstallprompt before the browser can fire it

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
